import { Role } from '@agilox/common';
import { MenuPoint, MenuPointCallbackAction } from '@agilox/ui-common';
import { MenuPointUrl } from '../enums/menupoint-url.enum';

export const manageMenuPoints = {
	users: {
		name: 'menu.users',
		url: MenuPointUrl.USERS,
		icon: 'users',
		roles: [Role.superuser, Role.support],
	} as MenuPoint,
	vehicles: {
		name: 'menu.vehicles',
		url: MenuPointUrl.VEHICLES,
		icon: 'robot_one',
		roles: [Role.support, Role.superuser],
	} as MenuPoint,
	notifications: {
		name: 'menu.notifications',
		url: MenuPointUrl.NOTIFICATIONS,
		icon: 'bell_ring',
		roles: [Role.superuser],
	} as MenuPoint,
	help: {
		name: 'menu.help',
		url: '',
		icon: 'o_quesmark',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.HELP,
	} as MenuPoint,
	logout: {
		name: 'general.logout',
		url: '',
		icon: 'logout',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.LOGOUT,
	} as MenuPoint,
};
